import { IWizardStep, IWizardStepsGroup } from '../models/IWizardStep'

import { getAllWizardSteps } from './getAllWizardSteps'
import { isWizardStepsGroup } from './isWizardStepsGroup'

export const findFirstIncompleteWizardStep = (data: (IWizardStep | IWizardStepsGroup)[]) => {
  for (const item of data) {
    if (isWizardStepsGroup(item)) {
      const incompleteStep = item.steps.find((step) => isIncomplete(step.completeness))
      if (incompleteStep) {
        return incompleteStep.id
      }
    } else if (isIncomplete(item.completeness)) {
      return item.id
    }
  }

  const firstStep = getAllWizardSteps(data).find((step) => !isWizardStepsGroup(step))

  return firstStep?.id || null
}

const isIncomplete = (completeness: number) => {
  return !!(completeness || completeness === 0) && completeness < 1 && completeness !== -1
}
